import AdvancedController from "./advanced-controller";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import s from "huntjs";

gsap.registerPlugin(ScrollTrigger);

export default class ShortFactController extends AdvancedController {
  static targets = [
    // 'content'
    "bigNumber",
  ];

  static values = {
    number: String,
  };

  connect() {
    super.connect();



    const element = this.bigNumberTarget;
    const finalNumber = parseInt(this.numberValue, 10); // Convert to integer

    if (this.numberValue && this.bigNumberTarget) {
      const scrollTrigger = ScrollTrigger.create({
        trigger: element,
        start: "bottom bottom",
        onEnter: () => this.animateNumber(element, finalNumber),
      });
    }
  }

  animateNumber(element, finalNumber) {
    const startTime = performance.now();
    const totalDuration = 3000; // Total duration in milliseconds
    const startNumber = 0;

    const step = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / totalDuration, 1); // Calculate progress

      const currentNumber = Math.floor(startNumber + progress * (finalNumber - startNumber));
      element.textContent = currentNumber.toLocaleString("de-DE", {
        minimumFractionDigits: 0, // No decimals for whole numbers
        maximumFractionDigits: 0,
      });

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        // Ensure final number is set after animation completes
        element.textContent = finalNumber.toLocaleString("de-DE", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
    };

    window.requestAnimationFrame(step);
  }
}
